'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INITIAL_ORDER_BY = exports.EventTable = exports.getEventRow = exports.getEventProperty = exports.INITIAL_COLUMN_HEADERS = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('immutable');

var _table = require('../../../../../table');

var _events = require('../../../../../events');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var HeaderCell = function HeaderCell(_ref) {
  var active = _ref.active,
      _ref$reverse = _ref.reverse,
      reverse = _ref$reverse === undefined ? false : _ref$reverse,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['active', 'reverse', 'children']);

  return _react2.default.createElement(
    _table.Cell,
    _extends({
      style: {
        fontWeight: active && 'bold',
        color: props.onClick && '#42bd41'
      }

    }, props),
    children,
    ' ',
    _react2.default.createElement('span', { className: 'fa ' + (active ? reverse ? 'fa-caret-down' : 'fa-caret-up' : '') })
  );
};

var INITIAL_COLUMN_HEADERS = exports.INITIAL_COLUMN_HEADERS = (0, _immutable.fromJS)([{ name: 'SelectForMerge', showCheckbox: false, visible: false, hideColumnName: true }, { name: 'Name', prop: 'name', showCheckbox: true, visible: true, csvMapping: 'name' }, { name: 'Type', prop: 'type', showCheckbox: true, visible: true, csvFunction: true, csvMapping: function csvMapping(ev) {
    return (0, _events.getEventLabel)(ev);
  } }, { name: 'Event', prop: 'event', showCheckbox: true, visible: true, gridTemplateColumn: '2fr', csvMapping: 'event' }, { name: 'Level', prop: 'level', showCheckbox: true, visible: true, gridTemplateColumn: '2fr', csvMapping: 'level' }, // Level / Category

{ name: 'Age', showCheckbox: true, visible: true, gridTemplateColumn: '1.5fr', csvFunction: true, csvMapping: function csvMapping(ev) {
    return (ev.get('adults') ? 'Adults' : ev.get('age')) + ' (' + (0, _events.getAgeDescription)(ev) + ')';
  } }, { name: 'Male', number: true, showCheckbox: true, visible: false, isStatisticsColumn: true, csvMapping: 'males' }, // # Male
{ name: 'Female', number: true, showCheckbox: true, visible: false, isStatisticsColumn: true, csvMapping: 'females' }, // # Female
{ name: 'Total', number: true, showCheckbox: true, visible: false, isStatisticsColumn: true, csvMapping: 'participants' }, // # Participants

{ name: 'Paid', number: true, showCheckbox: false, visible: true, isStatisticsColumn: true, csvMapping: 'paid' }, { name: 'Unpaid', number: true, showCheckbox: false, visible: true, isStatisticsColumn: true, csvMapping: 'unpaid' }, { name: 'Gender', showCheckbox: false, visible: true, csvFunction: true, csvMapping: function csvMapping(ev) {
    return (0, _events.getGenderLabel)(ev);
  } }, { name: 'Award Type', showCheckbox: false, visible: true, csvFunction: true, csvMapping: function csvMapping(ev) {
    return (0, _events.getAwardType)(ev);
  } }, { name: 'Place', showCheckbox: false, visible: true, csvFunction: true, csvMapping: function csvMapping(ev) {
    return (0, _events.getPlacementLabel)(ev);
  } }, { name: 'Irish Pts', showCheckbox: false, visible: true, csvFunction: true, csvMapping: function csvMapping(ev) {
    return ev.get('irish_points') ? 'true' : '';
  } }, { name: 'Rounds', number: true, showCheckbox: false, visible: true, csvFunction: true, csvMapping: function csvMapping(ev) {
    return ev.get('rounds') || '1';
  } }, { name: 'Fee', number: true, showCheckbox: false, visible: true, csvFunction: true, csvMapping: function csvMapping(ev) {
    return typeof ev.get('fee') === 'number' ? ev.get('fee') : '';
  } }, { name: 'No Fam Max', showCheckbox: false, visible: true, csvFunction: true, csvMapping: function csvMapping(ev) {
    return ev.get('exclude_from_max') ? 'true' : '';
  } }, { name: 'Recall', showCheckbox: false, visible: true, csvFunction: true, csvMapping: function csvMapping(ev) {
    return ev.get('recall') ? 'true' : '';
  } }]).map(function (col) {
  // default value for this column in 'grid-template-columns' CSS property is '1fr'
  return _extends({ gridTemplateColumn: '1fr' }, col.toObject());
});

var makeHeaderCells = function makeHeaderCells(_ref2) {
  var _ref2$headers = _ref2.headers,
      headers = _ref2$headers === undefined ? INITIAL_COLUMN_HEADERS : _ref2$headers,
      orderBy = _ref2.orderBy;
  return headers.map(function (col, idx) {
    var orderByColumn = orderBy.filter(function (orderByColumn) {
      return orderByColumn.get('name') === col.name;
    }).get(0);

    return col.visible && _react2.default.createElement(
      HeaderCell,
      {
        row: 1,
        column: idx + 1,
        reverse: orderByColumn && !orderByColumn.get('asc'),
        number: col.number,
        active: orderByColumn
      },
      col.hideColumnName ? '' : col.name
    );
  });
};

// TODO(boris): refactor to de-duplicate this redundancy and cache this for later to speed this up
var getEventProperty = exports.getEventProperty = function getEventProperty(ev, columnName) {
  return {
    'Name': ev.get('name'),
    'Type': (0, _events.getEventLabel)(ev),
    'Event': ev.get('event'),
    'Level': ev.get('level'),
    'Age': (ev.get('adults') ? 'Adults' : ev.get('age')) + ' (' + (0, _events.getAgeDescription)(ev) + ')',
    'Male': ev.get('males'),
    'Female': ev.get('females'),
    'Total': ev.get('participants'),
    'Paid': ev.get('paid'),
    'Unpaid': ev.get('unpaid'),
    'Gender': (0, _events.getGenderLabel)(ev),
    'Place': (0, _events.getPlacementLabel)(ev),
    'Irish Pts': ev.get('irish_points') ? 'true' : 'false', // sort as string
    'Rounds': ev.get('rounds') || '1',
    'Fee': typeof ev.get('fee') === 'number' ? ev.get('fee') : null,
    'No Fam Max': ev.get('exclude_from_max') ? 'true' : 'false', // sort as string
    'Recall': ev.get('recall') ? 'true' : 'false' // sort as string
  }[columnName];
};

var getEventRow = exports.getEventRow = function getEventRow(ev, row, headers, onClick, isEventIdSelected, toggleEventsToMerge) {
  var eventRowsMap = {
    'SelectForMerge': _react2.default.createElement('input', {
      checked: isEventIdSelected(ev.get('id')),
      onChange: function onChange() {
        return toggleEventsToMerge(ev.get('id'));
      },
      onClick: function onClick() {} /* disable default onClick */
      , type: 'checkbox'
    }),
    'Name': ev.get('name'),
    'Type': (0, _events.getEventLabel)(ev),
    'Event': ev.get('event'),
    'Level': ev.get('level'),
    'Age': (ev.get('adults') ? 'Adults' : ev.get('age')) + ' (' + (0, _events.getAgeDescription)(ev) + ')',
    'Male': ev.get('males'),
    'Female': ev.get('females'),
    'Total': ev.get('participants'),
    'Paid': ev.get('paid'),
    'Unpaid': ev.get('unpaid'),
    'Gender': (0, _events.getGenderLabel)(ev),
    'Award Type': (0, _events.getAwardType)(ev),
    'Place': (0, _events.getPlacementLabel)(ev),
    'Irish Pts': ev.get('irish_points') ? _react2.default.createElement('span', { className: 'fa fa-check' }) : null,
    'Rounds': ev.get('rounds') || '1',
    'Fee': typeof ev.get('fee') === 'number' ? ev.get('fee') : null,
    'No Fam Max': ev.get('exclude_from_max') ? _react2.default.createElement('span', { className: 'fa fa-check' }) : null,
    'Recall': ev.get('recall') ? _react2.default.createElement('span', { className: 'fa fa-check' }) : null
  };

  // create table cells in the same order as the headers are in
  return headers.map(function (column, idx) {
    // Do not render unvisible cells.
    if (!column.visible) {
      return null;
    }

    var cell = eventRowsMap[column.name];
    var customOnClick;

    if (cell && cell.props) {
      customOnClick = cell.props.onClick;
    }

    return _react2.default.createElement(
      _table.Cell,
      {
        row: row + 2,
        column: idx + 1,
        number: column.number,
        onClick: customOnClick || onClick
      },
      cell
    );
  });
};

// TODO(joshdmiller): only show certain columns base on the screen width.

var EventTable = exports.EventTable = function (_React$PureComponent) {
  _inherits(EventTable, _React$PureComponent);

  function EventTable(props) {
    _classCallCheck(this, EventTable);

    var _this = _possibleConstructorReturn(this, (EventTable.__proto__ || Object.getPrototypeOf(EventTable)).call(this, props));

    _this.isEventIdSelected = function (eventId) {
      return _this.state.eventsToMerge.includes(eventId);
    };

    _this.state = {
      events: props.events,
      eventsToMerge: props.eventsToMerge
    };
    return _this;
  }

  _createClass(EventTable, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(next) {
      if ((0, _immutable.is)(next.eventsToMerge, this.props.eventsToMerge) && (0, _immutable.is)(next.headers, this.props.headers) && (0, _immutable.is)(next.events, this.props.events)) {
        return;
      }

      this.setState({
        eventsToMerge: next.eventsToMerge,
        events: next.events
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          headers = _props.headers,
          selectEvent = _props.selectEvent,
          orderBy = _props.orderBy,
          toggleEventToMerge = _props.toggleEventToMerge;
      var events = this.state.events;


      var gridTemplateColumnValues = headers.map(function (header) {
        // don't allocate space for headers that aren't visible
        return header.visible ? header.gridTemplateColumn : '0fr';
      }).join(' ');

      return _react2.default.createElement(
        _table.Table,
        { columns: gridTemplateColumnValues },
        makeHeaderCells({ headers: headers, orderBy: orderBy }),
        events.flatMap(function (ev, row) {
          return getEventRow(ev, row, headers, function () {
            return selectEvent(ev);
          }, _this2.isEventIdSelected, toggleEventToMerge);
        })
      );
    }
  }]);

  return EventTable;
}(_react2.default.PureComponent);

var INITIAL_ORDER_BY = exports.INITIAL_ORDER_BY = (0, _immutable.fromJS)([{ name: 'mergeSplit' }]);

EventTable.defaultProps = {
  headers: INITIAL_COLUMN_HEADERS,
  events: (0, _immutable.List)(),
  orderBy: INITIAL_ORDER_BY,
  selectEvent: function selectEvent() {
    return null;
  }
};

EventTable.propTypes = {
  headers: _react2.default.PropTypes.instanceOf(_immutable.List),
  events: _react2.default.PropTypes.instanceOf(_immutable.List)
};


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/syllabus/table.js
// module id = 578
// module chunks = 0